export default __webpack_public_path__ + "static/media/navRight.d16b5825.svg";